{
    "MainTitleAdd": "Adicionar ambiente de gestão central",
    "MainTitleModify": "Modificar o ambiente de gestão central",
    "DomainsTitle": "Perfil do domínio",
    "ProvisioningTitle": "Aprovisionamento",
    "EstateTitle": "Estado",
    "UnknownDescription": "[Descrição desconhecida]",
    "LanguageCME_ButtonHelpLabel": "Ajuda?",
    "LanguageCME_ButtonSubmitLabel": "OK",
    "LanguageCME_ButtonCancelLabel": "Cancelar",
    "LanguageCME_PromptMessage": "Tem certeza de que deseja fechar esta janela? Todas as configurações modificadas serão perdidas ao fechá-la.",
    "LanguageCME_PromptConfirm": "sim",
    "LanguageCME_PromptCancel": "Cancelar",
    "LanguageCME_DetailsTitle": "Detalhes do CME",
    "NAME": "LanguageCME",
    "LicenseManagementTitle": "Gestão de Licenças",
    "CME_AdvancedTabTitle": "Avançado",
    "CME_Fields_RecursiveRealTimeBots": "Ativar\/desativar o tempo real para todos os servidores Tel",
    "CME_EnableVoiceAppBots": "Iniciar filas de espera em tempo real para {} Servidores Tel",
    "CME_EnableVoiceAppBots_Recursive": "Iniciar filas de espera em tempo real para todos os servidores Tel",
    "CME_DisableVoiceAppBots": "Parar filas de espera em tempo real para {} Servidores Tel",
    "CME_DisableVoiceAppBots_Recursive": "Parar as filas de espera em tempo real para todos os servidores Tel",
    "CME_EnableVoiceAppBots_Confirmation_Title": "Por favor, tenha em atenção que a ativação desta opção poderá levar à deterioração das funcionalidades no tenant. Esta opção apenas deverá ser utilizada após consultar a nossa equipa de suporte.",
    "CapabilitiesTitle": "Capacidades",
    "BrandingTitle": "Marca"
}